import { useEffect, useRef, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { api } from '../../api/client';
import { Alert } from '../../components/ui/Badge';
import { Button } from '../../components/ui/Button';
import { trackEvent } from '../../utils/tracking';

export function VerifyPage() {
  const { token } = useParams();
  const [message, setMessage] = useState('Verificando tu cuenta…');
  const [success, setSuccess] = useState(false);
  // El token solo se puede canjear una vez, así que en desarrollo la segunda
  // pasada de StrictMode fallaría y pisaría el resultado bueno.
  const requestedToken = useRef<string>();

  useEffect(() => {
    if (requestedToken.current === token) return;
    requestedToken.current = token;

    api
      .get<{ message: string }>(`/api/account/verify/${token}`)
      .then((result) => {
        trackEvent('cuenta_verificada');
        setMessage(result.message);
        setSuccess(true);
      })
      .catch((err: Error) => {
        setMessage(err.message);
        setSuccess(false);
      });
  }, [token]);

  return (
    <div className="auth-page">
      <div className="auth-card text-center">
        <h1>Verificación de cuenta</h1>
        <Alert tone={success ? 'success' : 'danger'}>{message}</Alert>
        <div style={{ marginTop: '1rem' }}>
          {success ? (
            <Link to="/login">
              <Button>Iniciar sesión</Button>
            </Link>
          ) : (
            <>
              <Link to="/reenviar-verificacion">
                <Button>Reenviar correo de verificación</Button>
              </Link>
              <p style={{ marginTop: '0.75rem' }}>
                <Link to="/login">Volver al login</Link>
              </p>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
